import { render, staticRenderFns } from "./DetailAffiliate.vue?vue&type=template&id=a69b05e2"
import script from "./DetailAffiliate.vue?vue&type=script&lang=js"
export * from "./DetailAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports